// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listProfile' }],
    name: 'get-all-profiles',
    sort: ['+name'],
});
